import { GenericMedicalList } from "./GenericMedicalList";

const DEVICE_TYPES = [
  "Pacemaker", "Implantable Cardioverter Defibrillator (ICD)",
  "Cochlear Implant", "Insulin Pump", "CGM (Continuous Glucose Monitor)",
  "Deep Brain Stimulator", "Vagal Nerve Stimulator",
  "Neurostimulator (Spinal)", "Neurostimulator (Peripheral)",
  "Orthopedic Implant (Knee)", "Orthopedic Implant (Hip)",
  "Orthopedic Implant (Spine)", "Orthopedic Implant (Shoulder)",
  "Dental Implant", "Prosthetic Limb", "Ventricular Assist Device",
  "Stent (Coronary)", "Stent (Vascular)", "IUD",
  "Contraceptive Implant", "Port-a-Cath", "PICC Line",
  "Feeding Tube (G-Tube)", "Feeding Tube (NG-Tube)", "Tracheostomy",
  "Ostomy", "CPAP Device", "BiPAP Device", "Home Ventilator",
];
const STATUS = ["Active", "Removed", "Replaced", "Malfunctioning", "Recalled"];

const DEFAULT = {
  device_type: "", manufacturer: "", model: "", serial_number: "",
  implanted_date: "", implanting_provider: "", facility: "",
  battery_replacement_due: "", last_check_date: "", next_check_date: "",
  status: "Active", mri_compatible: false, notes: "",
};

const COLUMNS = [
  { key: "device_type", label: "Device" },
  { key: "manufacturer", label: "Manufacturer" },
  { key: "implanted_date", label: "Implanted", format: "date" },
  { key: "status", label: "Status", format: "chip" },
  { key: "mri_compatible", label: "MRI Safe", format: "yesno" },
  { key: "next_check_date", label: "Next Check", format: "date" },
];

const FIELDS = [
  { key: "device_type", label: "Device Type", type: "select", options: DEVICE_TYPES, required: true, span: 2 },
  { key: "manufacturer", label: "Manufacturer" },
  { key: "model", label: "Model" },
  { key: "serial_number", label: "Serial Number" },
  { key: "status", label: "Status", type: "select", options: STATUS, required: true },
  { key: "implanted_date", label: "Implanted On", type: "date" },
  { key: "implanting_provider", label: "Implanting Provider" },
  { key: "facility", label: "Facility", span: 2 },
  { key: "battery_replacement_due", label: "Battery Replacement Due", type: "date" },
  { key: "last_check_date", label: "Last Interrogation or Check", type: "date" },
  { key: "next_check_date", label: "Next Scheduled Check", type: "date" },
  { key: "mri_compatible", label: "MRI Compatible", type: "checkbox", checkboxLabel: "MRI compatible (safe for MRI)" },
  { key: "notes", label: "Notes", type: "textarea", span: 2 },
];

export default function MedicalDevices({ client }) {
  return (
    <GenericMedicalList
      client={client}
      title="Medical Devices and Implants"
      subtitle="Pacemakers, pumps, orthopedic hardware, stimulators, and MRI compatibility."
      endpointList={(cid) => `/clients/${cid}/medical-devices`}
      endpointCreate={(cid) => `/clients/${cid}/medical-devices`}
      endpointUpdate={(id) => `/medical-devices/${id}`}
      endpointDelete={(id) => `/medical-devices/${id}`}
      columns={COLUMNS}
      formFields={FIELDS}
      defaultForm={DEFAULT}
      testPrefix="medical-devices"
      emptyText="No medical devices recorded"
    />
  );
}
